import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore, useTranslation } from '../../../../../hooks';
import { GameRedirectionSource } from '../../../../../enums';
import { integration } from '../../../../../services';
import { CashbackGame } from '../../../../../models';
import { env } from '../../../../../environment';
import { T } from '../../../../../constants';

interface RewardsGameTileProps {
  game: CashbackGame;
  onRedirect?: () => void;
}

export const RewardsGameTile: React.FC<RewardsGameTileProps> = observer(({ game, onRedirect }) => {
  const { gameStore } = useStore();
  const { isDemo } = gameStore;

  const t = useTranslation();

  const handleChangeGame = useCallback(() => {
    integration.current.changeGame({ gameId: game.gameId, source: GameRedirectionSource.Cashback });
    onRedirect?.();
  }, [game.gameId, onRedirect]);

  return (
    <div
      className="suggested-block-content-items"
    >
      <img
        src={`${env.filesUrl}/${game.thumbnailUrl}`}
        alt={game.gameName}
        className="suggested-bg"
      />
      <div className="play-now-demo-block">
        {!isDemo && (
          <button
            className="play-now-btn"
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              handleChangeGame();
            }}
          >
            {t(T.PLAY_NOW)}
          </button>
        )}
        <button
          className="demo-btn"
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            handleChangeGame();
          }}
        >
          {t(T.DEMO)}
        </button>
      </div>
    </div>
  );
});
